import type React from "react";

export function CreditCardEditIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.6666 8.3333H18.3333V6.8333C18.3333 5.8999 18.3333 5.4332 18.1516 5.0767C17.9918 4.7631 17.7369 4.5081 17.4233 4.3483C17.0668 4.1667 16.6 4.1667 15.6666 4.1667H4.3333C3.3999 4.1667 2.9332 4.1667 2.5766 4.3483C2.263 4.5081 2.0081 4.7631 1.8483 5.0767C1.6666 5.4332 1.6666 5.8999 1.6666 6.8333V13.1667C1.6666 14.1001 1.6666 14.5668 1.8483 14.9233C2.0081 15.2369 2.263 15.4919 2.5766 15.6517C2.9332 15.8333 3.3999 15.8333 4.3333 15.8333H9.1666M12.0833 17.5L13.7708 17.1625C13.9179 17.1331 13.9915 17.1184 14.0601 17.0914C14.121 17.0676 14.1788 17.0366 14.2325 16.9992C14.2929 16.957 14.346 16.904 14.4521 16.7979L17.9166 13.3333C18.3769 12.8731 18.3769 12.1269 17.9166 11.6667C17.4564 11.2064 16.7102 11.2064 16.25 11.6667L12.7854 15.1312C12.6793 15.2373 12.6263 15.2904 12.5841 15.3508C12.5467 15.4044 12.5157 15.4623 12.4918 15.5232C12.4649 15.5918 12.4502 15.6654 12.4208 15.8125L12.0833 17.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  );
}
